module.exports = __webpack_public_path__ + "img/logo_landing@2x.5b66426e.png";